import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";

export const createFreelancerSlice = (set, get) => ({
    freelancers: [],
    freelancersMetaData: [],
    freelancerDetail: {},

    getAllFreelancers: async (search = null, currentPage = null, nopagination = null, statuten = []) => {
        const usp = new URLSearchParams()
        if(search) usp.append('search', search)
        if(currentPage) usp.append('page', currentPage)
        if(nopagination) usp.append('nopagination', nopagination)
        if(statuten && statuten.length > 0) {
            statuten.forEach(s => usp.append('statuten[]', s))
        }

        await BaseClient().get('/freelancers?' + usp.toString())
            .then(response => {
                if (response.status === 200) {
                    set({freelancers: response.data?.data})
                    set({freelancersMetaData: response.data?.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },
    getFreelancerDetail: async (id) => {
        await BaseClient().get(`/freelancers/${id}`)
            .then(response => {
                if (response.status === 200) {
                    set({freelancerDetail: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },
    createFreelancer: async (data) => {
        await BaseClient().post('/freelancers', data)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    updateFreelancer: async (id, data) => {
        await BaseClient().post(`/freelancers/${id}`, data)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    deleteFreelancer: async (id) => {
        await BaseClient().delete(`/freelancers/${id}`)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    getFreelancerHourlyRate: async (freelancerId, branchId = null, useInternalRate = false) => {
        let params = {}
        if(branchId) {
            params = {...params, branch_id: branchId}
        }
        if(useInternalRate) {
            params = {...params, use_internal_rate: useInternalRate}
        }

        return await BaseClient().get(`/freelancers/${freelancerId}/hourly-rate?` + new URLSearchParams(params).toString())
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                    return null;
                }
            })
    },
    uploadFreelancerSignature: async (freelancerId, file) => {
        const formData = new FormData();
        formData.append('signature', file);

        return await BaseClient().post(`/freelancers/${freelancerId}/signature`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                if (response.status === 200) {
                    toast.success(i18next.t('freelancers_module.toast_signature_upload_success'));
                    return response.data;
                } else {
                    toast.error(response.data);
                    return null;
                }
            })
            .catch(error => {
                toast.error(i18next.t('freelancers_module.toast_signature_upload_error'));
                console.error('Error uploading signature:', error);
                return null;
            })
    },
    deleteFreelancerSignature: async (freelancerId) => {
        return await BaseClient().delete(`/freelancers/${freelancerId}/signature`)
            .then(response => {
                if (response.status === 200) {
                    toast.success(i18next.t('freelancers_module.toast_signature_delete_success'));
                    return true;
                } else {
                    toast.error(response.data);
                    return false;
                }
            })
            .catch(error => {
                toast.error(i18next.t('freelancers_module.toast_signature_delete_error'));
                console.error('Error deleting signature:', error);
                return false;
            })
    }
})